import { useCallback } from 'react';
import publicAxios from '../api/publicAxios';
import { useTranslation } from 'react-i18next';

interface TrackEventParams {
  workspaceId: string;
  userId?: string;
  type: 'page_view' | 'chat_message' | 'document_access' | 'session_start' | 'session_end';
  sessionId?: string;
  metadata?: {
      userAgent?: string;
      ip?: string;
      country?: string;
      referrer?: string;
      question?: string;
      responseTime?: number;
      messageLength?: number;
      documentId?: string;
      documentType?: string;
      sessionStartTime?: number;
      sessionEndTime?: number;
      duration?: number;
      pageViews?: number;
      messagesCount?: number;
    };
}

export const useAnalytics = () => {
  const { t } = useTranslation();
  const trackEvent = useCallback(async (params: TrackEventParams) => {
    try {
      // Générer un sessionId si pas fourni
      if (!params.sessionId) {
        params.sessionId = sessionStorage.getItem('analytics_session_id') || 
          `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('analytics_session_id', params.sessionId);
      }

      // Ajouter des métadonnées automatiques
      if (!params.metadata) params.metadata = {};
      if (!params.metadata.userAgent) {
        params.metadata.userAgent = navigator.userAgent;
      }
      if (!params.metadata.referrer) {
        params.metadata.referrer = document.referrer;
      }

      await publicAxios.post('/public/analytics/track', params);
    } catch (error) {
      console.error(t('error.console.errorTrackingAnalytics'), error);
    }
  }, []);

  const trackPageView = useCallback((workspaceId: string, userId?: string) => {
    trackEvent({
      workspaceId,
      userId: userId || 'Anonymous',
      type: 'page_view'
    });
  }, [trackEvent]);

  const trackChatMessage = useCallback((
    workspaceId: string, 
    question: string, 
    responseTime?: number,
    userId?: string
  ) => {
    trackEvent({
      workspaceId,
      userId: userId || 'Anonymous',
      type: 'chat_message',
      metadata: {
        question,
        responseTime,
        messageLength: question.length
      }
    });
  }, [trackEvent]);

    // ✅ NOUVELLE FONCTION POUR DOCUMENT ACCESS
  const trackDocumentAccess = useCallback((
    workspaceId: string,
    documentId: string,
    documentType: string,
    userId?: string
  ) => {
    trackEvent({
      workspaceId,
      userId: userId || 'anonymous',
      type: 'document_access',
      metadata: {
        documentId,
        documentType
      }
    });
  }, [trackEvent]);

  return {
    trackEvent,
    trackPageView,
    trackChatMessage,
    trackDocumentAccess
  };
};